import React from "react";

const CheckBoxSelectedIcon = () => {

    return (<svg width="32px" height="32px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"
                 fill="darkblue">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M0 0h48v48H0z" fill="none"></path>
                <g id="Shopicon">
                    <polygon
                        points="30.953,11.905 30.953,8.095 8.095,8.095 8.095,39.905 39.905,39.905 39.905,20.75 36.095,20.75 36.095,36.095 11.905,36.095 11.905,11.905 30.953,11.905"></polygon>
                    <polygon
                        points="41,7.172 24,24.172 17,17.172 14.171,20 21.172,27 21.171,27 24,29.828 26.828,27 43.828,10"></polygon>
                </g>
            </g>
        </svg>
    );
};

export default CheckBoxSelectedIcon;
